// src/Components/Settings/SettingsSection.jsx
// Web port of mobile's SettingsSection.tsx: uppercase section label + a
// bg-brand-surface card wrapper that clips its SettingsRow children so their
// dividers look continuous.
import React from "react";

const SettingsSection = ({ title, children }) => (
  <div className="mb-5">
    {title && (
      <h3 className="text-[11px] font-bold text-brand-textSecondary uppercase tracking-wide mb-2 px-1">
        {title}
      </h3>
    )}
    <div className="bg-brand-surface rounded-2xl border border-brand-border shadow-[0_1px_3px_rgba(0,0,0,0.04)] overflow-hidden">
      {children}
    </div>
  </div>
);

export default SettingsSection;
